import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCButton, RCCRefModalProps, RCCTooltip } from "react-common-components";
import Modal from "src/components/Modal";
import { useTranslation } from "src/context/Translations/context";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import useEffectSkipInitialRender from "src/hooks/useEffectSkipInitialRender";
import IFiltersActionsPanel, { ActionGroupers, IRefActionsPanelModalAddChangeDelete } from "../interface";
import ListOfActions, { IRefListOfActions } from "../listOfActions";
import ModalAddChangeDelete from "./modalAddChangeDelete";

export interface IRefModalSubaction {
    openModalSubactions: (id: number, actionParentTitle: string, listLayout: "card" | "list") => void;
}

interface IComponentModalSubaction{
    onCallbackClose: () => void;
}

const ModalsSubaction: React.ForwardRefRenderFunction<IRefModalSubaction, IComponentModalSubaction> = ({
	onCallbackClose
}, ref) => {
	const { translate } = useTranslation();
	const { setLoading } = useLoaderBackdrop();

	const modalsRef = useRef<IRefActionsPanelModalAddChangeDelete>(null);
	const listOfActionsRef = useRef<IRefListOfActions>(null);
	
	// Modal Subactions
	const modalSubactions = useRef<RCCRefModalProps>(null);
	const [subtitle, setSubtitle] = useState("");
	const [actionParent, setActionParent] = useState(0);
	const [layoutList, setLayoutList] = useState<"card" | "list">("card");
	
	const openModalSubactions = async (id: number, actionParentTitle: string, listLayout: "card" | "list") => {
		setLoading(true);
		setActionParent(id);
		setSubtitle(actionParentTitle);
		setLayoutList(listLayout);
		setLoading(false);
		modalSubactions.current?.openModal();	
	};

	const loadQuery = async () => {
		if(!listOfActionsRef.current)
			return;

		await listOfActionsRef.current.executeQuery();
	};

	useEffectSkipInitialRender(() => {
		loadQuery();
	}, [actionParent]);
	
	useImperativeHandle(ref, () => ({
		openModalSubactions
	}));
    
	return (
		<>			
			{/* Modal ADD/CHANGE */}
			<Modal
				ref={modalSubactions}
				header={{
					title: translate("Subações"),
					icon: {
						name: "tree"
					},
					subtitle
				}}
				footer= {{
					showSaveButton: false,
					buttonLoadingText: translate("Carregando"),
					saveButtonText: translate("Salvar"),
					cancelButtonText: translate("Cancelar")
				}}
				onClose={() => {
					if(onCallbackClose !== undefined)
						onCallbackClose();
				}}
				withoutForm
			>
				<ListOfActions 
					ref={listOfActionsRef}
					filters={{} as IFiltersActionsPanel}
					groupersSelect={{
						group: ActionGroupers.ACTIONS_WITH_SUBACTIONS,
						delayed: "",
						origin: ""
					}}
					groupers={{
						grouperId: actionParent
					}}
					layoutList={layoutList}
					positionOptions="leftEnd"
					header={{
						showTotal: true,
						button: <RCCTooltip
							text={translate("Nova subação")}
							color="purple"
							position="leftEnd"
						>
							<RCCButton
								icon={{name: "plus", color: "#FFF", size: 18}}
								color="purple"
								layout="isRounded"
								onClick={() => { if(!modalsRef.current) return; modalsRef.current.openModalAddOrChange(undefined, () => listOfActionsRef.current?.executeQuery(), undefined, actionParent, undefined, subtitle); }}
								size="md"
							/>
						</RCCTooltip>
					}}
				/>
			</Modal>
		
			{/* Modal ADD inside subactions */}
			<ModalAddChangeDelete ref={modalsRef} />
		</>
	);
};

export default forwardRef(ModalsSubaction);
